export default __webpack_public_path__ + "static/illustration_dashboard-9265588ba28accfab90887ebb3cc55c4.png";